var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 119,
    viewBox: "0 0 120 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_53_1126",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 119
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.886719,
    y: 0.482666,
    width: 118.227,
    height: 118.227,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_53_1126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.1048 82.256L87.8338 47.527L80.9373 40.6304L53.1048 68.4629L39.0654 54.4235L32.1688 61.3201L53.1048 82.256ZM60.0013 108.857C53.1869 108.857 46.7829 107.564 40.7895 104.978C34.7961 102.391 29.5826 98.8816 25.1491 94.4481C20.7156 90.0146 17.2058 84.8012 14.6195 78.8077C12.0333 72.8143 10.7402 66.4104 10.7402 59.5959C10.7402 52.7815 12.0333 46.3775 14.6195 40.3841C17.2058 34.3907 20.7156 29.1772 25.1491 24.7437C29.5826 20.3102 34.7961 16.8004 40.7895 14.2141C46.7829 11.6279 53.1869 10.3348 60.0013 10.3348C66.8158 10.3348 73.2197 11.6279 79.2131 14.2141C85.2066 16.8004 90.42 20.3102 94.8535 24.7437C99.287 29.1772 102.797 34.3907 105.383 40.3841C107.969 46.3775 109.262 52.7815 109.262 59.5959C109.262 66.4104 107.969 72.8143 105.383 78.8077C102.797 84.8012 99.287 90.0146 94.8535 94.4481C90.42 98.8816 85.2066 102.391 79.2131 104.978C73.2197 107.564 66.8158 108.857 60.0013 108.857Z",
    fill: "#00CB14"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.cb6ef8c926efed36c05c6685a4e44240.svg";
export { ForwardRef as ReactComponent };